import { useContext, useEffect, useRef } from "react";
import $ from "jquery";
import "jquery-nice-select/css/style.css";
import { Context } from "../../../context/Context";
window.jQuery = window.$ = $;
require("jquery-nice-select");
export default function Select({ classList, options, handleUpdate, tree, id }) {
  const selectRef = useRef();
  const { state, setState } = useContext(Context);
  useEffect(() => {
    $(selectRef.current).niceSelect();
    $(document).on("change", `#${id}`, (e) => {
      setState(handleUpdate(e.target.value, state, tree));
    });
  }, []);
  return (
    <select
      name={id}
      ref={selectRef}
      id={id}
      className={`${classList} mb-5 wide dark:bg-dark  flex items-center `}
    >
      {options.map(({ value, selected }, index) => (
        <option selected={selected} value={value} key={value} index={index}>
          {value}
        </option>
      ))}
    </select>
  );
}
